import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// Read `exp` off the JWT without verifying the signature — the server is the
// source of truth on validity, but decoding locally lets us bounce expired
// tokens to /admin/login before mounting the admin shell (avoiding the
// dashboard-then-login flash caused by an API 401 round-trip).
const isTokenLive = (token: string | null): boolean => {
  if (!token) return false;
  const parts = token.split('.');
  if (parts.length !== 3) return false;
  try {
    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
    );
    if (typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now()) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

const RequireAdminAuth: React.FC = () => {
  const location = useLocation();
  const token = localStorage.getItem('adminToken');

  if (!isTokenLive(token)) {
    if (token) localStorage.removeItem('adminToken');
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
};

export default RequireAdminAuth;
